export const version = "random/5.6.1";
//# sourceMappingURL=_version.js.map